import { CLINIC } from "@/lib/clinic";
import { MapPin, Phone, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1f2a25] text-stone-200 pt-16 pb-8"
    >
      <div className="container mx-auto px-6 sm:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-9 h-9 rounded-xl bg-[#FAFAF9] text-[#3A564A] font-display font-bold text-lg">
                D
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-display font-bold text-xl tracking-tight text-white">
                  Dent Square
                </span>
                <span className="font-devanagari text-[11px] text-stone-400 mt-0.5">
                  {CLINIC.nameHindi}
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm text-stone-400 leading-relaxed max-w-md">
              A women-owned, family-friendly dental clinic in Gomti Nagar,
              Lucknow. Painless dentistry, delivered with care.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#E08570] mb-4">
              Visit
            </p>
            <p className="text-sm text-stone-300 flex gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span>{CLINIC.address}</span>
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#E08570] mb-4">
              Contact
            </p>
            <a
              href={`tel:${CLINIC.phoneTel}`}
              className="text-sm text-stone-300 hover:text-white flex items-center gap-2"
            >
              <Phone className="w-4 h-4" /> {CLINIC.phoneDisplay}
            </a>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#E08570] mb-4">
              Hours
            </p>
            <p className="text-sm text-stone-300 flex items-center gap-2">
              <Clock className="w-4 h-4" /> Closes 9 pm
            </p>
            <p className="text-xs text-stone-500 mt-1">Open 7 days a week</p>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="text-xs text-stone-500">
            © {new Date().getFullYear()} Dent Square · Lucknow. All rights
            reserved.
          </p>
          <p className="text-xs text-stone-500">
            Crafted with care · 5.0★ on Google
          </p>
        </div>
      </div>
    </footer>
  );
}
